import { Box, Grid, IconButton, Stack, useTheme } from '@mui/material'
import { MdClose } from 'react-icons/md'
import LayoutBox from '../../../components/formGenerator/LayoutBox'
import { AddIcon } from './Icons'

const Form = ({
  layouts,
  disabled,
  onDrop,
  addLayout,
  deleteLayout,
  selectFormField,
  title,
  form,
  withColorLayout = false,
  onRearrange,
  cancelEnabled = false,
  pop = () => {},
  onContentChange,
  density = 'default',
  previewMode = false,
  isDraft = false,
}: any) => {
  const theme = useTheme()

  return (
    <Stack
      direction="column"
      sx={{
        width: '100%',
        flex: 1,
        minHeight: 0,
        alignSelf: 'stretch',
      }}
    >
      {cancelEnabled && (
        <Box display="flex" justifyContent="flex-end" sx={{ pr: 0.5, pt: 0.5 }}>
          <IconButton aria-label="close" onClick={pop} size="small" edge="end">
            <MdClose color={theme.palette.primaryMain[theme.palette.mode]} />
          </IconButton>
        </Box>
      )}

      <Box
        className={previewMode ? undefined : 'scrollbar'}
        sx={{
          width: '100%',
          flex: 1,
          minHeight: 0,
          maxHeight: previewMode ? 'none' : 'min(75dvh, calc(100vh - 200px))',
          overflowY: previewMode ? 'hidden' : 'auto',
          overflowX: 'hidden',
          px: density === 'compact' ? 0 : 1,
          py: density === 'compact' ? 0.25 : 0,
        }}
      >
        {disabled && !previewMode && (
          <Box display="flex" justifyContent="center" sx={{ py: 1 }}>
            <AddIcon onClick={() => addLayout(0)} />
          </Box>
        )}

        {layouts.map((row, index) => (
          <Grid
            key={`form-row-${index}`}
            container
            width="100%"
            paddingX={'5px'}
            spacing={density === 'compact' ? 1 : 2}
            sx={{ mb: density === 'compact' ? 1 : 2 }}
          >
            {row.columns.map((layout, indexCol) => (
              <LayoutBox
                previewMode={previewMode}
                size={12 / row.columns.length}
                key={`form-row-${index}-col-${indexCol}`}
                form={form}
                indexCol={indexCol}
                disabled={disabled}
                layoutIndex={index}
                layout={layout}
                withColorLayout={withColorLayout}
                density={density}
                onDrop={(indexVal, fieldIndex) => onDrop(indexVal, indexCol, fieldIndex)}
                onCreateLayout={columnIndex => addLayout(index, columnIndex)}
                deleteLayout={() => deleteLayout(index, indexCol)}
                setSelectedSettingField={selectFormField}
                onRearrange={onRearrange}
                onContentChange={onContentChange}
                isDraft={isDraft}
              />
            ))}
            {disabled && !previewMode && (
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" sx={{ py: 0.5 }}>
                  <AddIcon onClick={() => addLayout(index + 1)} />
                </Box>
              </Grid>
            )}
          </Grid>
        ))}
      </Box>
    </Stack>
  )
}

export default Form
